module.exports = __webpack_public_path__ + "img/wrestling.b07f2a88.svg";